import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from './join';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'C-TT2',
        sku: 'C-TT2',
        name: 'Tackling Type 2',
        variant: 'tt2-special',
        value: 297,
        currency: 'usd'
      }),
    []
  );
  return <SalesIndex ctaOverride="sales297" ctaNoTimer />;
}
